import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {LocationService} from "./location.service";


@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [LocationService],
  declarations: [],
  entryComponents: [],
  imports: [],
  exports: []
})
export class LocationModule {
}
